import React from "react";
import {styled} from "@mui/material/styles";
import Button from "@mui/material/Button";
import StyledContainer from "./_common/StyledContainer";
import StyledHeader from "./_common/StyledHeader";
import StyledSubheader from "./_common/StyledSubheader";

const StyledButton = styled(Button)(({theme}) => ({
  marginTop: theme.spacing(2),
}));

const NotFound = () => {
  return (
    <StyledContainer>
      <StyledHeader color="primary">
        404
      </StyledHeader>
      <StyledSubheader>
        Oops! The page you are looking for doesn’t exist.
      </StyledSubheader>
      <StyledButton
        variant="contained"
        color="primary"
        href="/"
      >
        Go Back to Home
      </StyledButton>
    </StyledContainer>
  );
};

export default NotFound;
